module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥物總存量:  " + _vm._s(_vm.selectedDrugTotalAmount))]), _c('span', {
    staticClass: "float-right"
  })]), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'actionWrap') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "amount": _vm.currentDrug.amount,
      "barcodeData": _vm.barcodeData,
      "schedules": _vm.schedules,
      "summarySelectedMed": _vm.summarySelectedMed,
      "reviewer": _vm.reviewer
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617a5650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrugScheduleFlow/ConfirmFlow.vue
// module id = 1490
// module chunks = 1